<template>
  <c-vertical-scheduler/>
</template>
<script>
import CVerticalScheduler from "@/components/CVerticalScheduler.vue";

export default {
  components: {CVerticalScheduler}
}
</script>